import { render, staticRenderFns } from "./amount.vue?vue&type=template&id=5984a0c3&scoped=true&"
import script from "./amount.vue?vue&type=script&lang=js&"
export * from "./amount.vue?vue&type=script&lang=js&"
import style0 from "./amount.vue?vue&type=style&index=0&id=5984a0c3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5984a0c3",
  null
  
)

export default component.exports